import { Box, Pagination } from "@bca/ui-library";
import React from "react";

import ShowVehiclesCount from "./ShowVehiclesCount";

interface VehiclesPaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (event: any, page: number) => void;
  isLoading: boolean;
  totalResultCount: number;
  pageSize: number;
}

const VehiclesPagination: React.FunctionComponent<VehiclesPaginationProps> = ({
  page,
  totalPages,
  onPageChange,
  isLoading,
  totalResultCount,
  pageSize,
}) => {
  const hideNextButton = totalPages === 1 || page === totalPages;
  const hidePrevButton = totalPages === 1 || page === 1;

  if (isLoading || totalResultCount === 0) return null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignSelf={{
        mobile: "center",
        desktop: "flex-start",
      }}
      marginTop="40px"
    >
      <Box
        alignSelf={{
          mobile: "center",
          desktop: "flex-start",
        }}
      >
        <Pagination
          disabled={isLoading}
          count={totalPages}
          page={page}
          defaultPage={1}
          onChange={onPageChange}
          hideNextButton={hideNextButton}
          hidePrevButton={hidePrevButton}
        />
      </Box>
      <ShowVehiclesCount
        totalResultCount={totalResultCount}
        pageSize={pageSize}
        isLastPage={page === totalPages}
      />
    </Box>
  );
};

export default VehiclesPagination;
